<div class="login-page">
    <div class="login-box">
        <div class="login-key">
            <i class="fa fa-user" aria-hidden="true"></i>
        </div>
        <div class="login-title">
            User Login
        </div>

        <form [formGroup]="loginForm" class="login-form">
            <div class="form-group">
                <label class="form-control-label">Email ID</label>
                <input type="email" class="form-control" formControlName="email" name="email">
            </div>
            <div class="form-group" *ngIf="showOTPInput">
                <label class="form-control-label">Access Code</label>
                <input type="text" class="form-control" formControlName="otp" name="otp">
            </div>

            <div class="login-button">
                <button type="button" class="btn btn-login" [disabled]="loginForm?.invalid || isBusy"
                    (click)="authenticateUser()">{{showOTPInput?'LOGIN':'REQUEST ACCESS CODE'}}</button>
            </div>

            <div class="login-text">
                <div class="loader text-center" *ngIf="isBusy"></div>
                <h6 class="boldwhite" *ngIf="showOTPInput && !showSurveyCompletedError">An access code has been sent to you email. Please enter the same to proceed.</h6>
                <h6 class="boldwhite" *ngIf="showSurveyCompletedError">Our records show that you have already taken the Survey. Please contact admin(Chelsea Idzior - chelsea.idzior&#64;adient.com) if you want to retake.</h6>
                <h6 class="boldred" *ngIf="showMandatoryError">Please fill in required fields.</h6>
                <h6 class="boldred" *ngIf="showOTPError">OTP request failed. Please try again or contact the
                    admin(Chelsea Idzior - chelsea.idzior&#64;adient.com).</h6>
                <h6 class="boldred" *ngIf="showLoginError">You are not authorized to access this application. Please contact admin(Chelsea Idzior - chelsea.idzior&#64;adient.com) for more details.
                </h6>
                <h6 class="browser-note">
                    ERM Survey is compatible only with the following browsers: <br/>
                    <strong>Google Chrome and Microsoft Edge </strong>
                </h6>
            </div>
        </form>
    </div>
</div>